import { useState } from 'react';
import {
  useChatSessions,
  useCurrentSession,
  useStreamChat,
  useCreateSession,
  useSwitchSession,
  useDeleteSession,
  useUpdateSessionTitle,
  useAddSystemMessage,
  useSendWidgetResponse,
  useSetInsightsContext,
  useSetSummaryThreadId,
  useSubmitFeedback,
} from './useChatQueries';

/**
 * Combined chat hook
 */
export const useChatTanStack = () => {
  const [sessionsEnabled, setSessionsEnabled] = useState(false);
  const sessionsQuery = useChatSessions(sessionsEnabled);
  const currentSessionQuery = useCurrentSession();
  
  const streamChatHook = useStreamChat();
  const createSessionMutation = useCreateSession();
  const switchSessionMutation = useSwitchSession();
  const deleteSessionMutation = useDeleteSession();
  const updateTitleMutation = useUpdateSessionTitle();
  const addSystemMessageMutation = useAddSystemMessage();
  const sendWidgetResponseMutation = useSendWidgetResponse();
  const setInsightsContext = useSetInsightsContext();
  const setSummaryThreadId = useSetSummaryThreadId();
  const submitFeedbackMutation = useSubmitFeedback();

  return {
    // TanStack Query objects
    sessionsQuery,
    currentSessionQuery,
    streamChatHook,
    createSessionMutation,
    switchSessionMutation,
    deleteSessionMutation,
    updateTitleMutation,
    addSystemMessageMutation,
    sendWidgetResponseMutation,
    setInsightsContext,
    setSummaryThreadId,
    submitFeedbackMutation,

    // Triggers the sessions fetch (call when history panel opens)
    fetchSessions: () => setSessionsEnabled(true),

    // Convenience data access
    sessions: sessionsQuery.data ?? [],
    currentSession: currentSessionQuery.data ?? null,
    
    // Aggregate loading states
    isLoading: currentSessionQuery.isLoading,
    isFetching: sessionsQuery.isFetching || currentSessionQuery.isFetching,
    error: sessionsQuery.error || currentSessionQuery.error,
  };
};
